import { render, staticRenderFns } from "./user-batch-allocate.vue?vue&type=template&id=65801634&scoped=true"
import script from "./user-batch-allocate.vue?vue&type=script&lang=ts"
export * from "./user-batch-allocate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65801634",
  null
  
)

export default component.exports